export const iconAddPhoto = <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
  <circle cx="18" cy="18" r="17" fill="#2F80ED" stroke="white" strokeWidth="2"/>
  <path
    d="M19.9863 11.6755V10.1755H16.9863V11.6755H19.9863ZM16.9863 25.2972V26.7972H19.9863V25.2972H16.9863ZM16.9863 11.6755V25.2972H19.9863V11.6755H16.9863Z"
    fill="white"/>
  <path
    d="M11.6758 16.9866H10.1758V19.9866H11.6758V16.9866ZM25.2974 19.9866H26.7974V16.9866H25.2974V19.9866ZM11.6758 19.9866H25.2974V16.9866H11.6758V19.9866Z"
    fill="white"/>
</svg>